import * as htmlToImage from "html-to-image";
import { useRef } from "react";
import { CiUser } from "react-icons/ci";
import { FaShareAlt } from "react-icons/fa";
import { FaX } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { IoShareSocialSharp } from "react-icons/io5";

interface ShowScoreProps {
	score: number;
	image: string;
	title: string;
	username: string;
	avatar: string | null;
	onClose: () => void;
	scoreSeason?: any;
}

const ShowScore = ({
	score,
	image,
	title,
	username,
	avatar,
	onClose,
	scoreSeason,
}: ShowScoreProps) => {
	const contentRef = useRef<HTMLDivElement>(null);

	const handleDownloadImage = async () => {
		const node = contentRef.current;
		if (!node) return;

		try {
			const dataUrl = await htmlToImage.toJpeg(node, {
				quality: 0.95,
				backgroundColor: "black",
				width: 400,
				height: node.scrollHeight,
				filter: (el) => el.tagName !== "BUTTON",
				cacheBust: true,
			});

			const link = document.createElement("a");
			link.download = `${title.replace(/\s/g, "_")}_score.jpg`;
			link.href = dataUrl;
			link.click();
			link.remove();
		} catch (error) {
			console.error("Error capturing and downloading image:", error);
			alert("Could not generate image for download.");
		}
	};

	// useEffect(() => {
	// 	const handleClickOutside = (event: MouseEvent) => {
	// 		if (
	// 			contentRef.current &&
	// 			!contentRef.current.contains(event.target as Node)
	// 		) {
	// 			onClose();
	// 		}
	// 	};

	// 	// مهار رویداد ماوس‌داون را به جای کل `document`، روی مودال کلی اضافه می‌کنیم
	// 	// این کار از کلیک ناخواسته روی دکمه دانلود جلوگیری می‌کند
	// 	const scoreViewer = document.getElementById("score-viewer");
	// 	if (scoreViewer) {
	// 		scoreViewer.addEventListener("mousedown", handleClickOutside);
	// 	}

	// 	return () => {
	// 		if (scoreViewer) {
	// 			scoreViewer.removeEventListener("mousedown", handleClickOutside);
	// 		}
	// 	};
	// }, [onClose]);

	const handleShare = async () => {
		if (!navigator.canShare) return handleDownloadImage();
		if (contentRef.current === null) return;

		const dataUrl = await htmlToImage.toJpeg(contentRef.current, {
			quality: 0.95,
		});
		const blob = await (await fetch(dataUrl)).blob();
		const file = new File([blob], `${title}_score.jpg`, { type: "image/jpeg" });

		if (navigator.canShare({ files: [file] })) {
			await navigator.share({
				title: !scoreSeason
					? `${title} Score`
					: `${title} Season: ${scoreSeason.season}, Episode: ${scoreSeason.episode} Score`,
				text: `Check out my ${title} score: ${score}/10!`,
				files: [file],
			});
		} else {
			handleDownloadImage();
		}
	};

	return (
		<div
			id="score-viewer"
			className="fixed inset-0 bg-black bg-opacity-90 flex flex-col justify-center items-center z-50"
		>
			<div className="absolute top-5 right-5 flex gap-4 justify-start items-center">
				<button
					className=" text-white text-xl hover:opacity-70 transition"
					onClick={onClose}
				>
					<FaX />
				</button>

				<button
					className="text-white text-xl hover:opacity-70 transition"
					onClick={handleDownloadImage}
					title="Download as JPG"
				>
					<FiDownload size={24} />
				</button>

				<button
					className=" text-white text-xl hover:opacity-70 transition"
					onClick={handleShare}
					title="Share"
				>
					<IoShareSocialSharp size={24} />
				</button>
			</div>

			{/* **contentRef: محتوایی که باید تصویربرداری شود** */}
			<div
				ref={contentRef}
				// کلاس w-[400px] را حفظ کردیم و h-80 را حذف کردیم
				className="flex flex-col w-[400px] bg-black text-white p-5 rounded-lg shadow-xl"
			>
				{/* لوگوی Cutin */}
				<div className="w-full text-center">
					<img
						className="m-auto"
						src="/cutin.svg"
						alt="Cutin"
						width={160}
						height={28}
						crossOrigin="anonymous" // برای SVGهای محلی نیز گاهی لازم است
					/>
				</div>
				<hr className="my-[18px]" />

				{/* تصویر فیلم */}
				<div className="rounded-xl overflow-hidden">
					<img
						src={image}
						alt={title}
						width={391}
						height={584}
						crossOrigin="anonymous"
					/>
				</div>

				{/* عنوان و امتیاز */}
				<div className="text-center mt-4">
					<p className="text-[36px] font-normal text-white">{title}</p>
					{scoreSeason && (
						<div className="flex justify-center gap-4">
							{scoreSeason.season && (
								<p className="text-[24px] font-normal text-white">
									فصل : {scoreSeason.season}
								</p>
							)}
							{scoreSeason.episode && (
								<p className="text-[24px] font-normal text-white">
									قسمت : {scoreSeason.episode}
								</p>
							)}
						</div>
					)}
					<div className="flex justify-center gap-5">
						<p className="text-[36px]" dir="ltr">
							{scoreSeason ? scoreSeason.score : score} / 10
						</p>
						<img
							src="/cib_score.svg"
							alt="score"
							width={55}
							height={46}
							crossOrigin="anonymous"
						/>
					</div>
				</div>
				<hr className="my-[18px]" />

				{/* نام کاربری و آواتار */}
				<div className="flex items-center justify-center gap-2">
					<p className="text-[22px] font-normal text-uppercase">{username}</p>
					{avatar ? (
						<img
							src={avatar}
							alt="avatar"
							width={24}
							height={24}
							crossOrigin="anonymous"
						/>
					) : (
						<CiUser size={24} className="mb-1" />
					)}
				</div>
			</div>
		</div>
	);
};

export default ShowScore;
